import React from 'react'
import PeopleYouMayKnowWidget from '../../../components/nemonto/PeopleYouMayKnowWidget'
import MyStatsWidget from '../../../components/nemonto/MyStatsWidget'
import '../../dashboard/social/social-list-page.css'
import '../../../components/nemonto/static-page.css'

// Restyled to match the nemonto theme (shares .nmsp-* classes with
// StaticCmsPage.js) and the same two-column "home screen" layout
// (.nmsl-layout main + right rail) as the other nemonto dashboard pages -
// the Sidebar nav is the way back, no in-page back button. The form has
// no backend endpoint yet - kept as a plain (non-submitting) layout
// rather than faking a "message sent" confirmation.
const ContactUs = () => (
    <div className="nmsl-layout">
        <div className="nmsl-main">
            <div className="nmsl-page-header">
                <div className="nmsl-header">
                    <h3 className="nmsl-title">Contact Us</h3>
                </div>
                <p className="nmsl-subtitle">Have a question or feedback? Send us a message below.</p>
            </div>

            <div className="nmsl-main-body">
                <div className="nmsp-card">
                    <form>
                        <div className="nmsp-field">
                            <label htmlFor="contact-name">Name</label>
                            <input type="text" id="contact-name" placeholder="Your name" />
                        </div>
                        <div className="nmsp-field">
                            <label htmlFor="contact-email">Email</label>
                            <input type="email" id="contact-email" placeholder="you@example.com" />
                        </div>
                        <div className="nmsp-field">
                            <label htmlFor="contact-message">Your message</label>
                            <textarea id="contact-message" placeholder="Tell us how we can help…" />
                        </div>
                        <div className="nmsp-submit-row">
                            <button type="button" className="nmsp-submit-btn">Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <aside className="nmsl-rail">
            <PeopleYouMayKnowWidget />
            <MyStatsWidget />
        </aside>
    </div>
)

export default ContactUs
